module.exports = __webpack_public_path__ + "static/media/SVGFb.1a008b3e.svg";